export default {
	aboutDetail: state => id => state.about[0]
}